import { css } from 'styled-components';

import { Colour } from '@xemplo/colours';

import { MinBreakpointV2 } from './media-query-v2';
import { Shadow } from './shadows';
import {
  BodyStandardMedium,
  BodyXSmallRegular,
  BodyXSmallSemiBold,
  LinkHoverLight,
  LinkUnderline,
} from './typography';

export class Card {
  public static readonly Container = css`
    display: flex;
    padding: 32px;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    flex-shrink: 0;
    border-bottom: 1px solid ${Colour.Dark[10]};
    background: ${Colour.Light[100]};
    cursor: pointer;
    &:hover {
      ${Shadow.Light1};
    }
    &.disabled {
      background: ${Colour.Gray[100]};
      cursor: not-allowed;
      pointer-events: none;
      &:hover {
        box-shadow: none;
      }
    }
    @media ${MinBreakpointV2.medium} {
      width: 320px;
      min-height: 180px;
      padding: 56px 32px;
    }
  `;

  public static readonly Title = css`
    text-align: center;
    color: ${Colour.Gray[500]};
    ${BodyStandardMedium};
  `;

  public static readonly Subtitle = css`
    text-align: center;
    color: ${Colour.Gray[400]};
    ${BodyXSmallRegular};
  `;

  public static readonly Link = css`
    ${LinkUnderline};
    ${LinkHoverLight};
    ${BodyXSmallSemiBold};
    &:visited,
    &:link,
    &:active {
      color: inherit;
    }
  `;
}
